export default function initNavigation() {
    const header = document.querySelector("[data-site-header]");
    const toggle = document.querySelector("[data-menu-toggle]");
    const menu = document.querySelector("[data-mobile-menu]");

    if (!header || !toggle || !menu) {
        return;
    }

    let lastFocused = null;

    const setOpen = (open) => {
        toggle.setAttribute("aria-expanded", String(open));
        toggle.setAttribute("aria-label", open ? "Fechar menu" : "Abrir menu");
        menu.hidden = !open;
        document.body.classList.toggle("menu-open", open);

        if (open) {
            lastFocused = document.activeElement;
            menu.querySelector("a")?.focus();
        } else if (lastFocused === toggle || menu.contains(lastFocused)) {
            toggle.focus();
        }
    };

    toggle.addEventListener("click", () => {
        setOpen(toggle.getAttribute("aria-expanded") !== "true");
    });

    document.addEventListener("keydown", (event) => {
        if (event.key === "Escape" && toggle.getAttribute("aria-expanded") === "true") {
            setOpen(false);
        }
    });

    document.addEventListener("click", (event) => {
        if (toggle.getAttribute("aria-expanded") === "true" && !header.contains(event.target)) {
            setOpen(false);
        }
    });

    menu.addEventListener("click", (event) => {
        if (event.target.closest("a")) {
            setOpen(false);
        }
    });

    const updateHeader = () => header.classList.toggle("is-scrolled", window.scrollY > 20);
    updateHeader();
    window.addEventListener("scroll", updateHeader, {passive: true});

    const desktopQuery = window.matchMedia("(min-width: 769px)");
    desktopQuery.addEventListener("change", (event) => {
        if (event.matches) {
            setOpen(false);
        }
    });
}
